import React from "react";
import "../../css/RadioSwitch.css";

function RadioSwitch({ name, value, label, checked, onChange }) {
  return (
    <label className="radio-switch">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
      />
      <span className="slider"></span>
      <span className="switch-label">{label}</span>
    </label>
  );
}

export default RadioSwitch;
